import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ExportsEffects, exportFeatureKey, exportsReducer } from './exports';

@NgModule({
  providers: [provideState({ name: exportFeatureKey, reducer: exportsReducer }), provideEffects(ExportsEffects)],
})
export class ExportsDataAccessModule {}
